export default{
    urologyPhysicalExamType: "نوع",
    genealogyPhysicalExamType: " نوع ژنیتالیا",
    varicocelePhysicalExamType: "نوع واریکوسل",
    hydrosolPhysicalExamType: "نوع هیدروسل",
    herniPhysicalExamType: "نوع هرنی",
    varicoceleGrade: "گرید واریکوسل",
    description: "توضیحات",
}